import { calendarDate, clockTime, addDays, validTimeZone } from 'utils/eventContract'

const compactDate = (date) => calendarDate(date).replace(/-/g, '')
const stamp = (date, time) => compactDate(date) + 'T' + clockTime(time).replace(':', '') + '00'
const escapeICS = (value) => String(value || '').replace(/\\/g, '\\\\').replace(/\r?\n/g, '\\n').replace(/[,;]/g, '\\$&')

export function getGoogleCalendarUrl(event) {
  const allDay = !event.startTime
  const start = allDay ? compactDate(event.startDate) : stamp(event.startDate, event.startTime)
  const end = allDay ? compactDate(addDays(event.endDate || event.startDate, 1))
    : stamp(event.endDate || event.startDate, event.endTime || event.startTime)
  const params = new URLSearchParams({
    action: 'TEMPLATE', text: event.eventName, dates: start + '/' + end,
    details: event.description || '', location: event.eventFormat === 'online' ? event.onlineUrl || 'Online' : event.locationAddress || '',
  })
  if (validTimeZone(event.timeZone)) params.set('ctz', event.timeZone)
  return 'https://www.google.com/calendar/render?' + params.toString()
}

export function generateICS(event) {
  const allDay = !event.startTime
  const zone = validTimeZone(event.timeZone) ? ';TZID=' + event.timeZone : ''
  const start = allDay ? 'DTSTART;VALUE=DATE:' + compactDate(event.startDate)
    : 'DTSTART' + zone + ':' + stamp(event.startDate, event.startTime)
  const end = allDay ? 'DTEND;VALUE=DATE:' + compactDate(addDays(event.endDate || event.startDate, 1))
    : 'DTEND' + zone + ':' + stamp(event.endDate || event.startDate, event.endTime || event.startTime)
  return ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Praysely//Events//EN', 'BEGIN:VEVENT',
    'UID:' + event._id + '@praysely.com',
    'DTSTAMP:' + new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''),
    'SUMMARY:' + escapeICS(event.eventName), 'DESCRIPTION:' + escapeICS(event.description),
    'LOCATION:' + escapeICS(event.eventFormat === 'online' ? event.onlineUrl : event.locationAddress),
    start, end, 'END:VEVENT', 'END:VCALENDAR', ''].join('\r\n')
}
  
